"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var color_1 = __importDefault(require("color"));
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var typography_1 = require("../../shared/theme/typography");
var styles = function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return (0, core_1.makeStyles)({
        root: __assign(__assign({}, material_kit_pro_react_1.container), (_a = { display: 'flex', flex: 1, flexDirection: 'column' }, _a[theme.breakpoints.down('xs')] = {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, _a)),
        ticketContainer: {
            marginTop: theme.spacing(2)
        },
        alignLeft: {
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
            paddingLeft: theme.spacing(1)
        },
        center: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        disclaimerText2: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2)
        },
        centerSmall: (_b = {},
            _b[theme.breakpoints.down('sm')] = {
                textAlign: 'center'
            },
            _b),
        ticketCard: {
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(3)
        },
        pendingPoints: {
            fontWeight: 'bold',
            marginRight: theme.spacing()
        },
        pendingData: {
            marginBottom: theme.spacing(1)
        },
        pendingMessage: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(6)
        },
        textField: {
            '& div input': __assign(__assign({ textAlign: 'center' }, theme.typography.subtitle1), { letterSpacing: 3 })
        },
        textFieldEntryCode: {
            '& div input': __assign(__assign({ textAlign: 'center' }, theme.typography.subtitle1), { letterSpacing: 1 })
        },
        button: {
            marginTop: '36px',
            marginBottom: theme.spacing(3),
            height: '48px',
            width: '160px',
            alignSelf: 'center'
        },
        playNowButton: (_c = {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(1),
                height: 40,
                alignSelf: 'center'
            },
            _c[theme.breakpoints.up('sm')] = {
                width: 425
            },
            _c[theme.breakpoints.down('xs')] = {
                width: '100%'
            },
            _c),
        skipButton: (_d = {
                alignSelf: 'center'
            },
            _d[theme.breakpoints.up('sm')] = {
                width: 425
            },
            _d[theme.breakpoints.down('xs')] = {
                width: '100%'
            },
            _d),
        link: {
            padding: 0
        },
        verticalPadding: {
            display: 'flex',
            paddingTop: theme.spacing(2),
            justifyContent: 'center'
        },
        primary: {
            color: theme.palette.primary.main,
            fontWeight: 'bold'
        },
        secondary: {
            color: theme.palette.secondary.main,
            fontWeight: 'bold'
        },
        dialogBackdrop: {
            backgroundColor: (0, color_1.default)(theme.palette.grey[500])
                .alpha(0.8)
                .rgb()
                .string()
        },
        dialog: {
            backgroundColor: theme.palette.background.default,
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
        dialogContent: {
            padding: 0
        },
        dialogActions: {
            marginBottom: theme.spacing(3)
        },
        flexDirectionColumn: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        flexDirectionRow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
        },
        earningData: {
            marginBottom: theme.spacing(3)
        },
        earningDialogCard: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.grey[300]
        },
        preAssignedDialogCard: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.secondary.main
        },
        earningSummaryDialogCard: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.secondary.main
        },
        secondaryContrast: {
            color: theme.palette.common.white
        },
        secondaryContrastBold: {
            color: theme.palette.common.white,
            fontWeight: 'bold'
        },
        textContrast: {
            color: theme.palette.text.primary
        },
        primaryColor: {
            color: theme.palette.primary.main
        },
        pointsContainer: (_e = {
                display: 'flex',
                flexDirection: 'row',
                padding: theme.spacing(3),
                justifyContent: 'space-evenly'
            },
            _e[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
                alignItems: 'center'
            },
            _e),
        disclamierContainer: (_f = {
                display: 'flex',
                padding: theme.spacing(2),
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                marginBottom: theme.spacing(2)
            },
            _f[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                marginBottom: theme.spacing(2)
            },
            _f),
        drawNameContainer: (_g = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
            },
            _g[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center'
            },
            _g),
        disclaimerText: {
            maxWidth: 400,
            minHeight: 40,
            color: "".concat(theme.palette.common.white, " !important")
        },
        bonusPointsContainer: (_h = {
                display: 'flex',
                flexDirection: 'row',
                padding: theme.spacing(2),
                justifyContent: 'space-evenly'
            },
            _h[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
                alignItems: 'center'
            },
            _h),
        bonusPointsPossible: {
            paddingBottom: theme.spacing(2),
            alignSelf: 'center',
            whiteSpace: 'normal',
            textAlign: 'center'
        },
        bonusPreAssigned: {
            paddingBottom: theme.spacing(1) / 2,
            alignSelf: 'center',
            whiteSpace: 'normal',
            textAlign: 'center'
        },
        secondChance: (_j = {
                display: 'flex',
                flexDirection: 'row'
            },
            _j[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
                alignItems: 'center'
            },
            _j),
        input: {
            textAlign: 'center',
            '&::placeholder': {
                textAlign: 'center',
                color: theme.palette.common.black,
                opacity: 0.6
            }
        },
        inputAdornment: {
            '& p': {
                color: 'rgba(12, 19, 26, 0.7)'
            }
        },
        earningDialogImage: (_k = {
                height: 110,
                width: 110,
                marginLeft: '-20%'
            },
            _k[theme.breakpoints.down('xs')] = {
                marginLeft: 0
            },
            _k),
        preAssignedDialogImage: (_l = {
                height: 110,
                width: 110,
                marginLeft: '-14%',
                alignSelf: 'center'
            },
            _l[theme.breakpoints.down('xs')] = {
                marginLeft: 0
            },
            _l),
        earningDialogIcon: {
            fontSize: 100,
            color: theme.palette.primary.main
        },
        pointsEarnedIcon: {
            height: 120,
            width: 150
        },
        earningDialogNotEligibleIcon: {
            fontSize: 100,
            color: theme.palette.action.disabled
        },
        earningDialogActions: {
            justifyContent: 'center'
        },
        earningDialogButton: {
            minWidth: 120,
            minHeight: 40
        },
        tabs: {
            marginBottom: theme.spacing(4),
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            '& button:hover, & button:active, & button:focus': (_m = {
                    color: theme.palette.primary.main
                },
                _m[theme.breakpoints.down('xs')] = {
                    fontSize: 12
                },
                _m)
        },
        check: {
            padding: 0
        },
        headingOpacity: {
            color: theme.palette.text.disabled
        },
        icon: {
            fontSize: 50,
            color: theme.palette.text.primary,
            marginRight: 4
        },
        totalEntriesContainer: {
            textAlign: 'center',
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
        congratulationsText: {
            paddingBottom: theme.spacing(3),
            textTransform: 'none'
        },
        wrapText: {
            '@media (max-width: 480px)': {
                whiteSpace: 'break-spaces',
                textAlign: 'center'
            }
        },
        ticketCardContainer: (_o = {
                display: 'flex',
                marginBottom: theme.spacing(6),
                justifyContent: 'center',
                alignItems: 'stretch',
                gap: '44px'
            },
            _o[theme.breakpoints.down('md')] = {
                flexDirection: 'column',
                alignItems: 'center'
            },
            _o),
        ticketCardContent: (_p = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                textAlign: 'center',
                flex: 1,
                flexGrow: 1,
                maxWidth: '480px',
                padding: '44px',
                margin: 0,
                backgroundColor: theme.palette.background.default
            },
            _p[theme.breakpoints.down('xs')] = {
                maxWidth: '100%'
            },
            _p),
        labelCenter: {
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center'
        },
        ticketTitle: (_q = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '36px'
            },
            _q[theme.breakpoints.up('lg')] = {
                textAlign: 'center'
            },
            _q),
        cardLabelStyle: {
            display: 'flex',
            paddingTop: theme.spacing(2),
            justifyContent: 'center',
            fontSize: '20px',
            fontFamily: typography_1.themeFonts.MontserratBold
        },
        inputListSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        },
        spacing: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        tooltipButton: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            textAlign: 'center',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '100%'
        },
        tooltipText: {
            textDecoration: 'none',
            textTransform: 'none',
            textAlign: 'center',
            fontFamily: typography_1.themeFonts.MontserratMedium,
            letterSpacing: '1.3px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '100%'
        },
        ticketLink: {
            padding: '0 35px',
            textAlign: 'center'
        },
        carouselContainer: {
            '& .slick-dots': (_r = {},
                _r[theme.breakpoints.down('xs')] = {
                    marginBottom: '-30px'
                },
                _r),
            '& .slick-dots ul': {
                padding: 0
            },
            '& .slick-dots li.slick-active button::before': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: '20px'
            },
            '& button.slick-arrow': {
                top: '40%',
                opacity: 1
            },
            '& .slick-dots li button::before': {
                borderRadius: '5px'
            },
            '& .slick-next::before, & .slick-prev::before': {
                color: theme.palette.primary.main,
                borderRadius: '50%',
                backgroundColor: 'white',
                border: '5px solid #fff',
                fontSize: '18px',
                boxShadow: '1px 1.5px 4px 0px rgba(170, 174, 181, 0.45)'
            },
            '& .slick-disabled::before': {
                color: '#bdbdbd!important'
            }
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map